import { IonDatetime, IonDatetimeButton, IonModal } from '@ionic/react';

interface CareerDatePickerProps {
  datetimeId: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}

const formatDate = (value: string) => {
  if (!value) return 'Seleccionar fecha';

  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day) return value;

  return new Intl.DateTimeFormat('es-ES', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(year, month - 1, day)));
};

// IonDatetime avoids the browser-native date popovers, whose layout differs
// between Safari, Chrome and the mobile WebViews used by Capacitor.
export const CareerDatePicker = ({
  datetimeId,
  label,
  value,
  onChange,
}: CareerDatePickerProps) => (
  <div>
    <p className="mb-1 text-sm font-semibold text-gray-700">{label}</p>
    <IonDatetimeButton className="career-date-picker-button" datetime={datetimeId}>
      <span slot="date-target">{formatDate(value)}</span>
    </IonDatetimeButton>

    <IonModal keepContentsMounted>
      <IonDatetime
        id={datetimeId}
        aria-label={label}
        presentation="date"
        locale="es-ES"
        firstDayOfWeek={1}
        value={value || null}
        showDefaultButtons
        cancelText="Cancelar"
        doneText="Aceptar"
        onIonChange={(event) => {
          const nextValue = event.detail.value;
          const date = Array.isArray(nextValue) ? nextValue[0] : nextValue;
          onChange(date?.slice(0, 10) ?? '');
        }}
      />
    </IonModal>
  </div>
);
